var exports = {
  "kL": "TextualAttachmentPreviewBottomSheet.module__container___U3NKSj",
  "Hy": "TextualAttachmentPreviewBottomSheet.module__codeContainer___U3NKSj",
  "Dy": "TextualAttachmentPreviewBottomSheet.module__codeSurface___U3NKSj",
  "qr": "TextualAttachmentPreviewBottomSheet.module__footer___U3NKSj",
  "qt": "TextualAttachmentPreviewBottomSheet.module__fileSection___U3NKSj",
  "gM": "TextualAttachmentPreviewBottomSheet.module__fileMeta___U3NKSj",
  "Md": "TextualAttachmentPreviewBottomSheet.module__fileName___U3NKSj",
  "Ov": "TextualAttachmentPreviewBottomSheet.module__fileSize___U3NKSj",
  "zt": "TextualAttachmentPreviewBottomSheet.module__footerActions___U3NKSj",
  "hP": "TextualAttachmentPreviewBottomSheet.module__actionButton___U3NKSj" + " " + __webpack_require__(180357)["AS"],
};

module.exports = exports;
